import { auditLogTypes, GRAY, ICON_BG_SYSTEM } from './auditlogsTypes';
import systemConfigIcon from 'dashboard/assets/images/audit_log_icons/system_config.svg';

const getAuditLogEntry = data => {
  const { auditable_type: auditableType, action, comment } = data;
  let key =
    auditableType && action
      ? `${auditableType.toLowerCase()}:${action.toLowerCase()}`
      : null;

  if (
    auditableType.toLowerCase() === 'accountuser' &&
    action.toLowerCase() === 'update'
  ) {
    key += data.user_id === data.auditable_id ? ':self' : ':other';
  }

  let auditlogEntry =
    auditLogTypes.find(type => type.id === key) ||
    auditLogTypes.find(type => type.id === comment);

  if (!data.user_id) {
    auditlogEntry = {
      ...auditlogEntry,
      colorClass: GRAY,
      icon: systemConfigIcon,
      iconBgClass: ICON_BG_SYSTEM,
      category: 'AUDIT_CATEGORIES.SYSTEM',
    };
  }

  return auditlogEntry;
};

export const getAuditableTypeLabel = auditLogItem => {
  if (!auditLogItem.user_id) return 'AUDIT_CATEGORIES.SYSTEM';

  const found = getAuditLogEntry(auditLogItem);
  return found
    ? found.category
    : auditLogItem.comment || 'AUDIT_CATEGORIES.SYSTEM';
};

export const getAuditLogColorClass = auditLogItem => {
  const found = getAuditLogEntry(auditLogItem);
  return found ? found.colorClass : GRAY;
};

export const getAuditLogIcon = auditLogItem => {
  const found = getAuditLogEntry(auditLogItem);
  return found ? found.icon : systemConfigIcon;
};

export const getAuditLogIconBgClass = auditLogItem => {
  const found = getAuditLogEntry(auditLogItem);
  return found ? found.iconBgClass : ICON_BG_SYSTEM;
};
